import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { userActions, userPermissions } from 'src/app/models/enums/user-permissions.enum';
import { ManagementApiService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { SecurityRoleService } from 'src/app/services/security-role.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import { PermissionHierarchy } from '../../../models/organization/security-role-permission.model';
import { UserTypePermissionModalComponent } from '../../modals/organization/user-type-permission-modal/user-type-permission-modal.component';
import { Subject } from 'rxjs';
import { GlobalEmittersService } from '../../../../../services/global-emitters.service';
import { takeUntil } from 'rxjs/operators';
import { Organization } from '../../../models/organization/organization.model';

@Component({
    selector: 'app-user-type',
    templateUrl: './user-type.component.html',
    styleUrls: ['./user-type.component.scss'],
    standalone: false
})
export class UserTypeComponent implements OnInit {
    @ViewChild(MatTable) table: MatTable<any>;
    destroy$: Subject<any>;

    displayedColumns: string[] = ['securityRoleName', 'roleDescription', 'actions'];
    userType = [];
    updatedUserTypeData = [];
    isNextButtonClicked: boolean = false;
    isSecurityRoleSaved: boolean = false;
    disableCancelButton = true;
    isDisableNext: boolean = false;
    currentOrganizationName: string;
    currentOrganizationId: string;
    dataSource: any = [];
    securityRolePermissions = [];
    securityRoleList: PermissionHierarchy[];
    securityRoleListCopy: PermissionHierarchy[];
    securityRoleListUpdate: PermissionHierarchy[] = [];
    tempList: any;
    newSecurityRolePermissions: any;
    userPermissions: userPermissions[];
    isFedOrg: boolean;
    isEditEnabled: boolean;
    isAddEnabled: boolean = false;
    isDeleteEnabled: boolean = false;
    activeOrganization: Organization;
    LicenseType: number = 0;
    constructor(
        private ngbModal: NgbModal,
        private activatedRoute: ActivatedRoute,
        private managementApiService: ManagementApiService,
        private organizationDataService: OrganizationDataService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private customToastServiceService: CustomToastService,
        private securityRoleService: SecurityRoleService,
        private userUtilityServices: UserUtilityService,
        private customToastService: CustomToastService,
        private globalEmittersService: GlobalEmittersService,
        private cd: ChangeDetectorRef
    ) {
        this.destroy$ = new Subject();
    }

    async ngOnInit(): Promise<void> {
        //if this is edit mode
        this.isEditEnabled = await this.userUtilityServices.checkUserPermissionDataAndRoute('org-SecurityRole', userActions.Edit);
        this.isAddEnabled = await this.userUtilityServices.checkUserPermissionDataAndRoute('org-SecurityRole', userActions.Create);
        this.isDeleteEnabled = await this.userUtilityServices.checkUserPermissionDataAndRoute('org-SecurityRole', userActions.Delete);
        if (this.organizationDataService.organizationData) {
            if (!this.organizationDataService.organizationData.licenseLimitiDMS) {
                this.LicenseType = 1; //Only Informate
            } else if (!this.organizationDataService.organizationData.licenseLimitICE) {
                this.LicenseType = 2; //Only Idms
            } else this.LicenseType = 0; //Both Idms and Informate
        }
        this.handleSubscription();
    }

    handleSubscription() {
        this.organizationDataService.activeOrganizationTab.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == 'Roles & Permission') {
                if (this.organizationDataService.organizationData) {
                    if (!this.organizationDataService.organizationData.licenseLimitiDMS) {
                        this.LicenseType = 1; //Only Informate
                    } else if (!this.organizationDataService.organizationData.licenseLimitICE) {
                        this.LicenseType = 2; //Only Idms
                    } else this.LicenseType = 0; //Both Idms and Informate
                }
                this.intializeComponant();
            }
        });

        this.organizationDataService.currentOrganizationName.pipe(takeUntil(this.destroy$)).subscribe((orgName) => {
            this.currentOrganizationName = orgName;
        });

        this.organizationDataService.isFederatedOrganization$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            this.isFedOrg = value;
        });

        this.globalEmittersService.currentOrganization.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.activeOrganization = res;
                this.filterSecurityRoles(res);
            }
        });

        this.organizationDataService.organizationTabNext.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == 'Roles & Permission') {
                this.saveSecurityRolePermission();
            }
        });

        this.organizationDataService.OrganizationTabBack.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == 'Roles & Permission') {
                this.navigateBack();
            }
        });
        this.organizationDataService.updateisSecurityRoleSaved.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            if (value) {
                this.isSecurityRoleSaved = true;
            }
        });
    }

    async intializeComponant() {
        if (this.activatedRoute.snapshot.paramMap.get('id') || this.organizationDataService.currentOrgId) {
            let orgId = this.activatedRoute.snapshot.paramMap.get('id')
                ? this.activatedRoute.snapshot.paramMap.get('id')
                : this.organizationDataService.currentOrgId;
            this.currentOrganizationId = orgId;
            await this.getSecurityRolesByOrganizationId(orgId);
            this.isSecurityRoleSaved = true;
            this.disableCancelButton = false;
        } else {
            this.getDefaultSecurityRoles();
            this.disableCancelButton = true;
        }

        await this.getSecurityPermissionsForNewRole();
    }

    // api to get the readily available security roles
    async getDefaultSecurityRoles() {
        try {
            if (!this.securityRoleList?.length) {
                this.ngxUiLoaderService.start();
                let securityRoles = await this.managementApiService.getSecurityRolesPermissionTemplate(true).toPromise();

                this.ngxUiLoaderService.stop();
                if (securityRoles.success === true) {
                    this.tempList = securityRoles.response;
                    this.securityRoleList = securityRoles.response.slice();
                    this.securityRoleListCopy = this.securityRoleList.slice();
                    this.securityRoleListUpdate = securityRoles.response.slice();
                    this.dataSource = securityRoles.response.slice();
                    // this.securityRolesData.emit(securityRoles.response);
                    this.securityRoleService.securityRoleList.next(securityRoles.response);
                } else if (securityRoles.message) {
                    this.userUtilityServices.errorModelPopup(securityRoles.message);
                }
            }
        } catch (e) {}
    }

    // function to edit/update  the security role
    editSecurityRole(securityRoleData: PermissionHierarchy) {
        // while adding the organization
        if (!this.activatedRoute.snapshot.paramMap.get('id')) {
            let editDialogRef = this.ngbModal.open(UserTypePermissionModalComponent, {
                size: 'lg',
            });
            let index = this.findSecurityRoleObject(securityRoleData.name);
            let securityRoleObject = JSON.parse(JSON.stringify(this.securityRoleListCopy[index]));
            editDialogRef.componentInstance.securityRoleName = securityRoleObject.name;
            editDialogRef.componentInstance.permissionTreeData = securityRoleObject;
            editDialogRef.componentInstance.modalMode = 'edit';
            editDialogRef.result
                .then((result) => {
                    if (result) {
                        // DISABLE THE OTHERS TABS
                        this.organizationDataService.isDisableUsersWizard.next(true);
                        this.organizationDataService.isDisableAzureDetailWizard.next(true);
                        this.organizationDataService.isDisableOrgTab$.next(true);
                        // DISABLE the back button
                        this.organizationDataService.isDisableBackButton$.next(true);

                        if (!this.isNextButtonClicked) {
                            this.securityRoleListCopy[index] = result;
                            // this.dataSource = this.securityRoleListCopy;
                            this.dataSource = this.organizationDataService.filterSecurityRolesByLicense(
                                this.securityRoleListCopy.slice(),
                                this.activeOrganization
                            ); // * filtering the security roles
                            // this.table.renderRows();
                            this.securityRoleService.securityRoleList.next(this.securityRoleListCopy);
                        } else {
                            this.securityRoleListCopy[index] = result;
                            // this.dataSource = this.securityRoleListCopy;
                            this.dataSource = this.organizationDataService.filterSecurityRolesByLicense(
                                this.securityRoleListCopy.slice(),
                                this.activeOrganization
                            ); // * filtering the security roles
                            // this.table.renderRows();
                            this.securityRoleService.securityRoleList.next(this.securityRoleListCopy);
                            let newIndex = this.findIndexOfSecurityRole(result.name, this.securityRoleListUpdate);
                            if (newIndex >= 0) {
                                this.securityRoleListUpdate[newIndex] = result;
                            } else {
                                this.securityRoleListUpdate.push(result);
                            }
                            //this.checkSecurityRoleInUpdateList(result);
                        }
                        this.customToastService.successToast('User role is edited successfully', 'Success');
                    }
                })
                .catch((error) => {
                    this.customToastService.errorToast('Error while updating the user role permissions', 'Error');
                });
        } else {
            // while edit the organization
            let editDialogRef = this.ngbModal.open(UserTypePermissionModalComponent, {
                size: 'lg',
            });
            let index = this.findSecurityRoleObject(securityRoleData.name);
            let securityRoleObject = JSON.parse(JSON.stringify(this.securityRoleListCopy[index]));
            editDialogRef.componentInstance.securityRoleName = securityRoleObject.name;
            editDialogRef.componentInstance.permissionTreeData = securityRoleObject;
            editDialogRef.componentInstance.modalMode = 'edit';
            editDialogRef.result
                .then((result) => {
                    if (result) {
                        // DISABLE the other tabs
                        this.organizationDataService.isDisableUsersWizard.next(true); /************** */
                        this.organizationDataService.isDisableAzureDetailWizard.next(true);
                        this.organizationDataService.isDisableOrgTab$.next(true);
                        // DISABLE the back button
                        this.organizationDataService.isDisableBackButton$.next(true);
                        this.securityRoleListCopy[index] = result;
                        this.dataSource = this.securityRoleListCopy;
                        this.table.renderRows();
                        this.securityRoleService.securityRoleList.next(this.securityRoleListCopy);
                        let newIndex = this.findIndexOfSecurityRole(result.name, this.securityRoleListUpdate);
                        if (newIndex >= 0) {
                            this.securityRoleListUpdate[newIndex] = result;
                        } else {
                            this.securityRoleListUpdate.push(result);
                        }
                        //this.checkSecurityRoleInUpdateList(result);
                        this.customToastService.successToast('User role is edited successfully', 'Success');
                    }
                })
                .catch((error) => {
                    this.customToastService.errorToast('Error while updating the user role permissions', 'Error');
                });
        }
    }

    // api to add the new role
    copySecurityRole(securityRoleData: PermissionHierarchy) {
        // copy mode
        if (!this.activatedRoute.snapshot.paramMap.get('id')) {
            let addDialogRef = this.ngbModal.open(UserTypePermissionModalComponent, {
                size: 'lg',
            });
            let index = this.findSecurityRoleObject(securityRoleData.name);
            let securityRoleObject = JSON.parse(JSON.stringify(this.securityRoleListCopy[index]));
            addDialogRef.componentInstance.securityRoleName = securityRoleObject.name;
            addDialogRef.componentInstance.permissionTreeData = securityRoleObject;
            addDialogRef.componentInstance.modalMode = 'copy';
            addDialogRef.componentInstance.permissionTreeData = JSON.parse(JSON.stringify(securityRoleObject));
            addDialogRef.result
                .then((result) => {
                    if (result) {
                        this.organizationDataService.isDisableUserTypeWizard.next(true); /************* */
                        if (!this.isNextButtonClicked) {
                            this.securityRoleListCopy.push(result);
                            this.organizationDataService.filterSecurityRolesByLicense(this.securityRoleListCopy.slice(), this.activeOrganization); // * filtering the security roles
                            this.table.renderRows();
                            this.securityRoleService.securityRoleList.next(this.securityRoleListCopy);
                            this.checkSecurityRoleInUpdateList(result);
                        } else {
                            this.securityRoleListCopy.push(result);
                            this.organizationDataService.filterSecurityRolesByLicense(this.securityRoleListCopy.slice(), this.activeOrganization); // * filtering the security roles
                            this.table.renderRows();
                            this.securityRoleService.securityRoleList.next(this.securityRoleListCopy);
                            let newIndex = this.findIndexOfSecurityRole(result.name, this.securityRoleListUpdate);
                            if (newIndex >= 0) {
                                this.securityRoleListUpdate[newIndex] = result;
                            } else {
                                this.securityRoleListUpdate.push(result);
                            }
                        }
                        this.customToastService.successToast('User role is copied successfully', 'Success');
                    }
                })
                .catch((error) => {
                    this.customToastService.errorToast('Error while saving the user role permissions', 'Error');
                });
        } else {
            // edit mode
            let addDialogRef = this.ngbModal.open(UserTypePermissionModalComponent, {
                size: 'lg',
            });
            let index = this.findSecurityRoleObject(securityRoleData.name);
            let securityRoleObject = JSON.parse(JSON.stringify(this.securityRoleListCopy[index]));
            addDialogRef.componentInstance.securityRoleName = securityRoleObject.name;
            addDialogRef.componentInstance.permissionTreeData = securityRoleObject;
            addDialogRef.componentInstance.modalMode = 'copy';
            addDialogRef.componentInstance.permissionTreeData = JSON.parse(JSON.stringify(securityRoleObject));
            addDialogRef.result
                .then((result) => {
                    if (result) {
                        this.organizationDataService.isDisableUsersWizard.next(true);
                        this.securityRoleListCopy.push(result);
                        this.dataSource = this.securityRoleListCopy;
                        this.table.renderRows();
                        this.securityRoleService.securityRoleList.next(this.securityRoleListCopy);
                        let newIndex = this.findIndexOfSecurityRole(result.name, this.securityRoleListUpdate);
                        if (newIndex >= 0) {
                            this.securityRoleListUpdate[newIndex] = result;
                        } else {
                            this.securityRoleListUpdate.push(result);
                        }
                        this.customToastService.successToast('User role is copied successfully', 'Success');
                    }
                })
                .catch((error) => {
                    this.customToastService.errorToast('Error while saving the user role permissions', 'Error');
                });
        }
    }

    // api to get default security permissions new role
    getSecurityPermissionsForNewRole() {
        if (!this.newSecurityRolePermissions?.length) {
            this.managementApiService.getSecurityPermissionsForNewRole().subscribe((defaultRolePermission) => {
                if (defaultRolePermission.success === true) {
                    this.newSecurityRolePermissions = defaultRolePermission.response;
                } else {
                    this.userUtilityServices.errorModelPopup(defaultRolePermission.message);
                }
            });
        }
    }

    // helper method to find the securityRoleObject
    findSecurityRoleObject(securityRoleName) {
        let position = 0;
        for (const [index, securityRole] of this.securityRoleListCopy.entries()) {
            if (securityRole.name === securityRoleName) {
                position = index;
                break;
            }
        }
        return position;
    }

    // api to add the new role
    addNewSecurityRole() {
        // add mode
        if (!this.activatedRoute.snapshot.paramMap.get('id')) {
            let addDialogRef = this.ngbModal.open(UserTypePermissionModalComponent, {
                size: 'lg',
            });
            addDialogRef.componentInstance.modalMode = 'add';

            let newpermissionTreeData = new PermissionHierarchy();
            newpermissionTreeData.securityRolePermissions = JSON.parse(JSON.stringify(this.newSecurityRolePermissions));
            addDialogRef.componentInstance.permissionTreeData = newpermissionTreeData;
            addDialogRef.result
                .then((result) => {
                    if (result) {
                        // DISABLE the tabs
                        this.organizationDataService.isDisableUsersWizard.next(true);
                        this.organizationDataService.isDisableAzureDetailWizard.next(true);
                        this.organizationDataService.isDisableOrgTab$.next(true);
                        // DISABLE the back button
                        this.organizationDataService.isDisableBackButton$.next(true);

                        this.securityRoleListCopy.push(result);
                        // this.dataSource = this.securityRoleListCopy;
                        this.dataSource = this.organizationDataService.filterSecurityRolesByLicense(this.securityRoleListCopy.slice(), this.activeOrganization); // * filtering the security roles
                        this.table.renderRows();
                        this.securityRoleService.securityRoleList.next(this.securityRoleListCopy);

                        this.securityRoleListUpdate.push(result);
                        this.customToastService.successToast('User role permissions are saved successfully', 'Success');
                    }
                })
                .catch((error) => {
                    this.customToastService.errorToast('Error while saving the user role permissions', 'Error');
                });
        } else {
            // edit mode
            let addDialogRef = this.ngbModal.open(UserTypePermissionModalComponent, {
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
            });
            addDialogRef.componentInstance.modalMode = 'add';
            let newpermissionTreeData = new PermissionHierarchy();
            newpermissionTreeData.securityRolePermissions = JSON.parse(JSON.stringify(this.newSecurityRolePermissions));
            addDialogRef.componentInstance.permissionTreeData = newpermissionTreeData;
            addDialogRef.result
                .then((result) => {
                    if (result) {
                        // DISABLE the tabs
                        this.organizationDataService.isDisableUsersWizard.next(true);
                        this.organizationDataService.isDisableAzureDetailWizard.next(true);
                        this.organizationDataService.isDisableOrgTab$.next(true);
                        // DISABLE the back button
                        this.organizationDataService.isDisableBackButton$.next(true);
                        this.securityRoleListCopy.push(result);
                        // this.dataSource = this.securityRoleListCopy;
                        this.dataSource = this.organizationDataService.filterSecurityRolesByLicense(this.securityRoleListCopy.slice(), this.activeOrganization); // * filtering the security roles
                        this.table.renderRows();
                        this.securityRoleService.securityRoleList.next(this.securityRoleListCopy);
                        this.securityRoleListUpdate.push(result);
                        this.customToastService.successToast('User role permissions are saved successfully', 'Success');
                    }
                })
                .catch((error) => {
                    this.customToastService.errorToast('Error while saving the user role permissions', 'Error');
                });
        }
    }

    // api to save the security roles and its permissions
    async saveSecurityRolePermission() {
        this.isNextButtonClicked = true;
        let routeOrgId = this.activatedRoute.snapshot.paramMap.get('id');
        if (this.isNextButtonClicked && !this.isSecurityRoleSaved && !routeOrgId && this.securityRoleListUpdate?.length > 0) {
            try {
                this.ngxUiLoaderService.start();
                let securityRoles = await this.managementApiService
                    .addSecurityRole(this.organizationDataService.organizationData.organisationId, this.securityRoleListUpdate)
                    .toPromise();

                if (securityRoles.success === true) {
                    await this.getSecurityRolesByOrganizationIdAPICall(this.organizationDataService.organizationData.organisationId);
                    // this.securityRoleList = securityRoles.response.slice();
                    // this.securityRoleListCopy = securityRoles.response.slice();
                    // this.dataSource = this.securityRoleListCopy;
                    // this.table.renderRows();
                    this.isSecurityRoleSaved = true;
                    this.securityRoleListUpdate = [];
                    this.organizationDataService.setUserSecurityRoles(this.securityRoleListCopy);
                    // ENABLE the tabs
                    this.roleTabnavigation();
                    this.ngxUiLoaderService.stop();
                } else if (securityRoles.message) {
                    this.ngxUiLoaderService.stop();
                    this.userUtilityServices.errorModelPopup(securityRoles.message);
                }
            } catch (e) {
                this.ngxUiLoaderService.stop();
                this.userUtilityServices.errorModelPopup(e.message);
            }
        } else if (this.securityRoleListUpdate.length > 0) {
            try {
                this.ngxUiLoaderService.start();
                let result = await this.managementApiService
                    .updateSecurityRole(this.organizationDataService.organizationData.organisationId, this.securityRoleListUpdate)
                    .toPromise();

                if (result.success === true) {
                    await this.getSecurityRolesByOrganizationIdAPICall(this.organizationDataService.organizationData.organisationId);
                    // this.securityRoleList = result.response.slice();
                    // this.securityRoleListCopy = result.response.slice();
                    // this.dataSource = this.securityRoleListCopy;
                    // this.table.renderRows();
                    this.isSecurityRoleSaved = true;
                    this.securityRoleListUpdate = [];
                    this.organizationDataService.setUserSecurityRoles(this.securityRoleListCopy);
                    this.securityRoleListUpdate = [];
                    this.ngxUiLoaderService.stop();
                    this.roleTabnavigation();
                } else if (result.message) {
                    this.ngxUiLoaderService.stop();
                    this.userUtilityServices.errorModelPopup(result.message);
                }
            } catch (e) {
                this.ngxUiLoaderService.stop();
                this.userUtilityServices.errorModelPopup(e.message);
            }
        } else {
            // just navigate to next tab in wizard
            // ENABLE the tabs
            this.roleTabnavigation();
        }
    }

    // api to get the security roles by organization id (for edit mode)
    async getSecurityRolesByOrganizationId(orgId: string) {
        if (!this.securityRoleList?.length) {
            await this.getSecurityRolesByOrganizationIdAPICall(orgId);
        }
    }

    async getSecurityRolesByOrganizationIdAPICall(orgId: string) {
        try {
            this.ngxUiLoaderService.start();
            let securityRoles = await this.managementApiService.getSecurityRolesByOrgId(orgId).toPromise();
            if (securityRoles.success === true) {
                this.dataSource = securityRoles.response;
                this.securityRoleList = securityRoles.response;
                this.securityRoleListCopy = securityRoles.response;

                this.cd.detectChanges();
                // this.securityRoleListUpdate = securityRoles.response;
                this.securityRoleListUpdate = [];
                this.organizationDataService.setUserSecurityRoles(this.securityRoleList);
                this.securityRoleService.securityRoleList.next(securityRoles.response);
                this.filterSecurityRoles(this.activeOrganization);
            } else {
                this.userUtilityServices.errorModelPopup(securityRoles.message);
            }
            this.ngxUiLoaderService.stop();
        } catch (e) {
            this.ngxUiLoaderService.stop();
            this.userUtilityServices.errorModelPopup(e.message);
        }
    }

    // api to delete the security roles
    deleteSecurityRoles(securityRoleData: PermissionHierarchy) {
        let deleteDialogRef = this.ngbModal.open(DeleteDialogComponent, {
            size: 'sm',
        });
        deleteDialogRef.componentInstance.modalMessage = `<p>Do you want to delete <b>${securityRoleData.name}</b> security role? </p>`;
        deleteDialogRef.result
            .then((dialogResult) => {
                if (dialogResult) {
                    if (this.checkSecurityRoleID(securityRoleData)) {
                        this.deleteSecurityRole(securityRoleData.securityRoleId, securityRoleData);
                    } else {
                        this.securityRoleListCopy = this.securityRoleListCopy.filter((securityRole) => securityRole.name !== securityRoleData.name);
                        this.securityRoleListUpdate = this.securityRoleListUpdate.filter((securityRole) => securityRole.name !== securityRoleData.name);
                        this.dataSource = this.securityRoleListCopy;
                        // TODO this static message will be replaced and it will be taken from json/constant file
                        this.customToastServiceService.successToast('Security role deleted successFully!', 'Success');
                        this.securityRoleService.securityRoleList.next(this.securityRoleListCopy);
                        this.organizationDataService.setUserSecurityRoles(this.securityRoleListCopy);
                    }
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    // helper method to check the name is not duplicate or not
    checkDuplicateName(securityRoleName: string) {
        for (const [index, securityRole] of this.securityRoleListCopy.entries()) {
            if (securityRole.name === securityRoleName) {
                return false;
            }
        }
        return true;
    }

    findIndexOfSecurityRole(securityRoleName: string, securityRoleArray: PermissionHierarchy[]) {
        let index = -1;
        for (const [index, role] of securityRoleArray.entries()) {
            if (role.name.toLocaleLowerCase().replace(/ /g, '') === securityRoleName.toLocaleLowerCase().replace(/ /g, '')) {
                return index;
            }
        }
        return index;
    }

    // helper method to check weather the role contains the securityRoleId or not
    checkSecurityRoleID(securityRoleData: PermissionHierarchy): boolean {
        if (securityRoleData.securityRoleId) {
            return true;
        } else {
            return false;
        }
    }

    utilityDelete(securityRoleData: PermissionHierarchy) {
        if (this.checkSecurityRoleID(securityRoleData)) {
            this.securityRoleListCopy = this.securityRoleListCopy.filter((securityRole) => securityRole.name !== securityRoleData.name);
            // securityRoleData.active = 0;
            this.dataSource = this.securityRoleListCopy;
            this.securityRoleService.securityRoleList.next(this.securityRoleListCopy);
            this.securityRoleListUpdate.push(securityRoleData);
        } else {
            this.securityRoleListCopy = this.securityRoleListCopy.filter((securityRole) => securityRole.name !== securityRoleData.name);
            this.dataSource = this.securityRoleListCopy;
            this.securityRoleService.securityRoleList.next(this.securityRoleListCopy);
            this.securityRoleListUpdate = this.securityRoleListUpdate.filter((securityRole) => securityRole.name !== securityRoleData.name);
        }
    }

    // api to delete the security role
    deleteSecurityRole(securityRoleId, securityRoleData) {
        this.ngxUiLoaderService.start();
        this.managementApiService.updateSecurityRole(this.currentOrganizationId, [{ securityRoleId: securityRoleId, active: false }]).subscribe(
            (result) => {
                this.ngxUiLoaderService.stop();
                if (result.success === true) {
                    // TODO this static message will be replaced and it will be taken from json/constant file
                    this.customToastServiceService.successToast('Security role deleted successFully!', 'Success');
                    this.securityRoleListCopy = this.securityRoleListCopy.filter((securityRole) => securityRole.name !== securityRoleData.name);
                    this.dataSource = this.securityRoleListCopy;
                    this.securityRoleService.securityRoleList.next(this.securityRoleListCopy);
                    // ENABLE the tabs
                    this.organizationDataService.isDisableUsersWizard.next(false);
                    this.organizationDataService.isDisableInstanceWizard.next(false);
                    this.organizationDataService.isDisableOrgTab$.next(false);
                    this.organizationDataService.isDisableAzureDetailWizard.next(false);
                    // ENABLE the back button
                    this.organizationDataService.isDisableBackButton$.next(false);
                    this.organizationDataService.setUserSecurityRoles(this.securityRoleListCopy);
                } else {
                    this.userUtilityServices.errorModelPopup(result.message);
                }
            },
            (error) => {
                this.ngxUiLoaderService.stop();
            }
        );
    }

    checkSecurityRoleInUpdateList(result) {
        if (this.securityRoleListUpdate.length > 0) {
            this.securityRoleListUpdate.forEach((element) => {
                let indexx = this.securityRoleListUpdate.indexOf(result);
                if (element.securityRoleId === result.securityRoleId && element.name === result.name && indexx > -1) {
                    this.securityRoleListUpdate[indexx] = result;
                } else {
                    this.securityRoleListUpdate.push(result);
                }
            });
        } else {
            this.securityRoleListUpdate.push(result);
        }
    }

    viewRolesPermissions(securityRoleData: PermissionHierarchy) {
        let viewDialogRef = this.ngbModal.open(UserTypePermissionModalComponent, {
            size: 'lg',
        });
        let index = this.findSecurityRoleObject(securityRoleData.name);
        let securityRoleObject = JSON.parse(JSON.stringify(this.securityRoleListCopy[index]));
        viewDialogRef.componentInstance.permissionTreeData = securityRoleObject;
        viewDialogRef.componentInstance.modalMode = 'view';
        viewDialogRef.result
            .then((result) => {
                if (result) {
                    this.organizationDataService.isDisableUsersWizard.next(true); /************** */
                    this.securityRoleListCopy[index] = result;
                    this.dataSource = this.securityRoleListCopy;
                    this.table.renderRows();
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    }

    navigateBack() {
        //set to false
        this.organizationDataService.isDisableUserTypeWizard.next(true); // set to true
        if (this.isFedOrg) {
            this.organizationDataService.isDisableAzureDetailWizard.next(false);
            this.organizationDataService.navigateThroughWizard.next(1);
        } else {
            this.organizationDataService.isDisableOrgTab$.next(false);
            this.organizationDataService.navigateThroughWizard.next(0);
        }
    }

    // * filter security roles
    filterSecurityRoles(organization: Organization) {
        // if(!this.securityRoleListCopy)
        //   return;
        // if (
        //     organization.licenseLimitICE > 0 &&
        //     organization.licenseLimitiDMS == 0
        // ) {
        //     this.securityRoleList =
        //         this.organizationDataService.filterSecurityRolesByLicense(
        //             JSON.parse(JSON.stringify(this.securityRoleListCopy.slice())),
        //             LicenseWiseSecurityRoles.onlyInformate
        //         );
        // } else if (
        //     organization.licenseLimitiDMS > 0 &&
        //     organization.licenseLimitICE == 0
        // ) {
        //     this.securityRoleList =
        //         this.organizationDataService.filterSecurityRolesByLicense(
        //             JSON.parse(JSON.stringify(this.securityRoleListCopy.slice())),
        //             LicenseWiseSecurityRoles.onlyIdms
        //         );
        // } else {
        //     this.securityRoleList =
        //     this.organizationDataService.filterSecurityRolesByLicense(
        //       JSON.parse(JSON.stringify(this.securityRoleListCopy.slice())),
        //       LicenseWiseSecurityRoles.idmsInformate
        //       );
        //     }
        this.securityRoleList = this.organizationDataService.filterSecurityRolesByLicense(this.securityRoleListCopy, organization);
        this.dataSource = this.securityRoleList;
        // this.table.renderRows();
    }

    roleTabnavigation() {
        this.organizationDataService.isDisableUsersWizard.next(false);
        this.organizationDataService.isDisableInstanceWizard.next(true);
        this.organizationDataService.isDisableOrgTab$.next(true); // set to true for disable
        this.organizationDataService.isDisableAzureDetailWizard.next(true);
        this.organizationDataService.isDisableUserTypeWizard.next(true); // set to true for disable
        //ENABLE the back button
        this.organizationDataService.isDisableBackButton$.next(false);
        if (this.isFedOrg) {
            this.organizationDataService.navigateThroughWizard.next(3);
        } else {
            this.organizationDataService.navigateThroughWizard.next(2);
        }
    }
    DataSource() {
        if (this.organizationDataService.organizationData) {
            if (!this.organizationDataService.organizationData.licenseLimitiDMS) {
                this.LicenseType = 1; //Only Informate
            } else if (!this.organizationDataService.organizationData.licenseLimitICE) {
                this.LicenseType = 2; //Only Idms
            } else this.LicenseType = 0; //Both Idms and Informate
        }
        if (this.LicenseType == 1) {
            return this.dataSource.filter((item) => !item.name.toUpperCase().includes('IDMS'));
        } else if (this.LicenseType == 2) {
            return this.dataSource.filter((item) => !item.name.toUpperCase().includes('INFORMATE'));
        } else return this.dataSource;
    }
    ngOnDestroy(): void {
        this.isSecurityRoleSaved = false;
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
